import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, Grid, Icon } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { submit, reset } from 'redux-form';

import * as CommonStateSelectors from 'State/selectors';
import { CLOSE_PRODUCTION_FORM_NAME } from 'Common/FormEnum';

import { CloseProductionForm } from './CloseProductionForm';

class CloseProductionModal extends React.Component {
  static propTypes = {
    modalProps: PropTypes.object,
    headerTitle: PropTypes.string,
    prodRecord: PropTypes.object,
    isReadOnly: PropTypes.bool,
    showComments: PropTypes.bool,
    loading: PropTypes.bool,
  };

  static defaultProps = {
    isReadOnly: true,
    showComments: true,
    loading: false,
  };

  render() {
    const {
      headerTitle,
      modalProps,
      prodRecord,
      userName,
      index,
      sitesMap,
      submit,
      isReadOnly,
      showComments,
      onSubmit,
      loading,
    } = this.props;
    const { onClose } = modalProps;

    return (
      <Modal {...modalProps} className="ep-close-modal">
        <Modal.Header className="manage-menu-modal-header">
          {headerTitle}
          <Icon name="close" onClick={onClose} className="manage-menu-close" />
        </Modal.Header>
        <Modal.Content className="manage-menu-modal-content">
          <Form>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  {prodRecord && (
                    <CloseProductionForm
                      prodRecord={prodRecord}
                      sitesMap={sitesMap}
                      userName={userName}
                      index={index}
                      onSubmit={onSubmit}
                      isReadOnly={isReadOnly}
                      showComments={showComments}
                    />
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <div className="manage-menu-header-buttons">
            <Button onClick={modalProps.onClose} className="mnm-button-blue">
              Done
            </Button>
            <Button
              onClick={() => submit(CLOSE_PRODUCTION_FORM_NAME)}
              loading={loading}
              className="mnm-button-blue"
              disabled={isReadOnly || loading}
            >
              Close & Submit
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}
const mapStateToProps = state => ({
  userName: CommonStateSelectors.getUserName(state),
  sitesMap: CommonStateSelectors.getSitesMap(state),
});

const mapDispatchToProps = {
  submit,
  reset,
};

CloseProductionModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(CloseProductionModal);

export { CloseProductionModal };



// WEBPACK FOOTER //
// ./src/pages/manageproduction/subpages/editproduction/components/CloseProductionModal.js